"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Whatsapp;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Whatsapp(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: ".cls-1{fill:#010101;}"
    }
  })), /*#__PURE__*/_react["default"].createElement("title", null, "WhatsApp"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Contact"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "whatsapp",
    className: "cls-1",
    d: "M78.018,21.625A39.655,39.655,0,0,0,15.625,69.464L10,90l21.018-5.518A39.518,39.518,0,0,0,49.964,89.3h.018C71.821,89.3,90,71.518,90,49.661A39.8,39.8,0,0,0,78.018,21.625Zm-28.036,61A32.9,32.9,0,0,1,33.2,78.036L32,77.321,19.536,80.589l3.321-12.16-.786-1.25A33.014,33.014,0,1,1,83.3,49.661C83.3,67.839,68.143,82.625,49.982,82.625ZM68.054,57.946c-.983-.5-5.858-2.892-6.768-3.214-.911-.339-1.572-.5-2.232.5s-2.554,3.214-3.143,3.893c-.572.661-1.161.75-2.143.25-5.822-2.911-9.643-5.2-13.482-11.786-1.018-1.75,1.018-1.625,2.91-5.41a1.836,1.836,0,0,0-.089-1.733c-.25-.5-2.232-5.375-3.053-7.357-.8-1.928-1.625-1.66-2.233-1.7-.571-.036-1.232-.036-1.892-.036a3.668,3.668,0,0,0-2.643,1.232,11.13,11.13,0,0,0-3.465,8.268c0,4.875,3.554,9.589,4.036,10.25.5.661,6.982,10.661,16.929,14.964,6.285,2.715,8.75,2.947,11.893,2.483,1.91-.286,5.857-2.393,6.678-4.715s.822-4.3.572-4.714C69.7,58.679,69.036,58.429,68.054,57.946Z"
  })));
}